import { useEffect, useState, useRef } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { openMiniCart } from 'libs/cart'
import CustomModalDialog from 'snippets/custom-modal-dialog/custom-modal-dialog'
import PersonaliseContentModal from 'snippets/personalise-content-modal/personalise-content-modal'
import Icon from 'snippets/icon/icon'

const PersonaliseProductModal = () => {
  const [modalData, setModalData] = useState({})
  const [product, setProduct] = useState({})
  const [status, setStatus] = useState('AddToCart')
  const [existingCharms, setExistingCharms] = useState([])
  const [editingCharmPosition, setEditingCharmPosition] = useState(null)
  const [cartItem, setCartItem] = useState(null)
  const [showOnboarding, setShowOnboarding] = useState(true)
  const openedFromCartRef = useRef(false)

  useEffect(() => {
    globalEmitter.on(emitterProps.personaliseModal.show, (data) => {
      setModalData(data?.modal || {})
      setProduct(data?.product || {})
      setStatus(data?.status || 'AddToCart')
      setExistingCharms(data?.existingCharms || [])
      setEditingCharmPosition(data?.editingCharmPosition || null)
      setCartItem(data?.cartItem || null)
      // Reset onboarding when modal opens, unless editing
      setShowOnboarding(data?.status !== 'Edit')
      // Track if opened from cart
      openedFromCartRef.current = data?.status === 'Edit' || data?.status === 'AddFromCart'
    })

    return () => {
      globalEmitter.off(emitterProps.personaliseModal.show, () => {})
    }
  }, [])

  // Listen for modal close event to reopen cart if needed
  useEffect(() => {
    const modalEl = document.querySelector('modal-dialog[data-target="personalise-product-modal"]')

    const handleModalClose = () => {
      if (openedFromCartRef.current) {
        // Small delay to ensure modal is fully closed before reopening cart
        setTimeout(() => {
          openMiniCart()
        }, 100)
        openedFromCartRef.current = false
      }
    }

    modalEl?.addEventListener('close-modal', handleModalClose)

    return () => {
      modalEl?.removeEventListener('close-modal', handleModalClose)
    }
  }, [])

  const modalHeader = modalData?.modalHeader || translate?.general?.personalise?.modal_header || 'Make it personal'

  const handleToggleOnboarding = () => {
    setShowOnboarding(!showOnboarding)
  }

  const handleDismissOnboarding = () => {
    setShowOnboarding(false)
  }

  // Custom header with info button
  const headerContent = (
    <>
      <span className="flex-1">{modalHeader}</span>
      <button
        type="button"
        className={`p-[11px] transition-colors rounded-full border-[0.5px] ${showOnboarding ? 'bg-[#F0F0F0] border-black' : 'border-transparent hover:bg-[#F0F0F0]'}`}
        onClick={handleToggleOnboarding}
        aria-label="Toggle instructions"
      >
        <Icon
          name="icon-info-personalisation"
          className="w-4 h-4 text-black"
          viewBox="0 0 16 16"
        />
      </button>
    </>
  )

  return (
    <CustomModalDialog
      id="personalise-product-modal"
      classMain="w-full sm:max-w-[424px] flex flex-col h-[100dvh]"
      classHeader="w-full modal-dialog-header font-serif italic text-xl leading-[20px] text-default border-b border-[#e7e7e7] "
      classContent="personalise-modal-content flex flex-col flex-1 overflow-y-auto"
      classClose="h-[40px] w-[40px] rounded-full hover:bg-[#F0F0F0] transition-colors flex items-center justify-center"
      content={
        <PersonaliseContentModal
          modalData={modalData}
          product={product}
          status={status}
          existingCharms={existingCharms}
          editingCharmPosition={editingCharmPosition}
          cartItem={cartItem}
          showOnboarding={showOnboarding}
          onDismissOnboarding={handleDismissOnboarding}
        />
      }
      type="slideout"
      header={headerContent}
    />
  )
}

export default PersonaliseProductModal
